import { render, staticRenderFns } from "./OnList.vue?vue&type=template&id=5c5237e5&scoped=true&"
import script from "./OnList.vue?vue&type=script&lang=js&"
export * from "./OnList.vue?vue&type=script&lang=js&"
import style0 from "./OnList.vue?vue&type=style&index=0&id=5c5237e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5237e5",
  null
  
)

export default component.exports